{
  "DATA_ASSISTANT": {
    "TITLE": "Daten-Assistent",
    "NEW_CONVERSATION": "+ Neu",
    "LOADING": "Wird geladen...",
    "LOADING_MESSAGES": "Nachrichten werden geladen...",
    "THINKING": "Denke nach...",
    "UNTITLED": "Unbenannte Unterhaltung",
    "NO_CONVERSATIONS": "Noch keine Unterhaltungen. Klicken Sie auf '+ Neu', um zu beginnen.",
    "EMPTY_STATE": "Wählen Sie eine Unterhaltung aus oder erstellen Sie eine neue, um zu beginnen.",
    "SEND": "Senden",
    "PLACEHOLDER": "Was kann ich für Sie herausfinden?",
    "SHOW_SQL": "SQL anzeigen",
    "NO_ROWS": "Keine Zeilen zurückgegeben.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Unterhaltung löschen",
    "DELETE_CONFIRM_DESCRIPTION": "Sind Sie sicher, dass Sie diese Unterhaltung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "DELETE_CONFIRM_YES": "Löschen",
    "CHAT": "Chat",
    "REPORTS": "Berichte",
    "SAVE_TO_REPORT": "In Bericht speichern",
    "NEW_REPORT": "Neuer Bericht",
    "REPORT_NAME": "Berichtsname",
    "NO_REPORTS": "Noch keine gespeicherten Berichte",
    "REPORTS_EMPTY_STATE": "Wählen Sie einen Bericht aus oder erstellen Sie einen neuen.",
    "REPORT_SAVED": "In Bericht gespeichert",
    "DELETE_REPORT_CONFIRM": "Bericht löschen",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Sind Sie sicher, dass Sie diesen Bericht löschen möchten? Alle gespeicherten Elemente werden entfernt.",
    "DELETE_ITEM_CONFIRM": "Element entfernen",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Sind Sie sicher, dass Sie dieses Element aus dem Bericht entfernen möchten?",
    "EXPORT_CSV": "CSV exportieren",
    "REFRESH": "Aktualisieren",
    "QUERY_RUNNING": "Abfrage läuft...",
    "QUERY_FAILED": "Abfrage fehlgeschlagen",
    "AUTO_REFRESH": "Automatisch aktualisieren",
    "AUTO_REFRESH_NONE": "Manuell",
    "AUTO_REFRESH_30S": "30 Sekunden",
    "AUTO_REFRESH_1M": "1 Minute",
    "AUTO_REFRESH_5M": "5 Minuten",
    "AUTO_REFRESH_10M": "10 Minuten",
    "EDIT_MESSAGE": "Nachricht bearbeiten",
    "RENAME_REPORT": "Bericht umbenennen",
    "RENAME_ITEM": "Element umbenennen",
    "MOVE_UP": "Nach oben",
    "MOVE_DOWN": "Nach unten",
    "COLLABORATORS": {
      "BUTTON": "Mitwirkende",
      "TITLE": "Mitwirkende am Bericht",
      "DESCRIPTION": "Wählen Sie, welche Agenten und Teams diesen Bericht einsehen können.",
      "AGENTS": "Agenten",
      "TEAMS": "Teams",
      "SELECT_AGENTS": "Agenten auswählen",
      "SELECT_TEAMS": "Teams auswählen",
      "SAVE": "Speichern",
      "SAVED": "Mitwirkende aktualisiert",
      "SAVE_FAILED": "Mitwirkende konnten nicht aktualisiert werden"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Berichte"
}
